// The three iOS "Add to Home Screen" steps.
//
// Used by the install banner's modal AND by the public /install page. It
// lives here so there is exactly ONE copy of the instructions: the day the
// wording or the Share icon changes, it changes in both places.

export default function IosInstallSteps() {
  return (
    <ol className="space-y-3">
      <Step n="1" icon={<ShareIcon />}>
        Tap the <b>Share</b> button at the bottom of Safari
      </Step>
      <Step
        n="2"
        icon={
          <span
            aria-hidden
            className="flex h-8 w-8 items-center justify-center rounded-lg border border-line bg-white text-[18px] text-navy"
          >
            ＋
          </span>
        }
      >
        Scroll down and tap <b>Add to Home Screen</b>
      </Step>
      <Step n="3">
        Tap <b>Add</b> — the Ghost icon lands on your home screen
      </Step>
    </ol>
  )
}

function Step({ n, icon, children }) {
  return (
    <li className="flex items-center gap-3 rounded-xl bg-[#F9FAFB] p-3">
      <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-navy text-[12px] font-extrabold text-white">
        {n}
      </span>
      <span className="flex-1 text-[13px] text-navy">{children}</span>
      {icon}
    </li>
  )
}

export function ShareIcon() {
  return (
    <span aria-hidden className="flex h-8 w-8 items-center justify-center rounded-lg border border-line bg-white">
      <svg width="16" height="18" viewBox="0 0 16 18" fill="none" stroke="#1F7AE0" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <path d="M8 11V1.5M4.5 5 8 1.5 11.5 5" />
        <path d="M5 8H3.5A1.5 1.5 0 0 0 2 9.5v6A1.5 1.5 0 0 0 3.5 17h9a1.5 1.5 0 0 0 1.5-1.5v-6A1.5 1.5 0 0 0 12.5 8H11" />
      </svg>
    </span>
  )
}
